import { languageMap } from ".."

languageMap.gettext = {
	comments: {
		line: "#",
	},
}
